import './App.css';
import Home from './Component/Pages/Home';
import {Route,Routes} from 'react-router'
import PrivacyPolicy from './Component/Pages/PrivacyPolicy';
import TermsAndConditions from './Component/Pages/TermsAndConditions';
function App() {

  return (
    <div>
      <Routes>
        <Route path="/" element={<Home/>}/>
        <Route path="/privacy-policy" element={<PrivacyPolicy/>}/>
        <Route path="/terms-and-conditions" element={<TermsAndConditions/>}/>
      </Routes>
    </div>
  );
}

export default App;
